export enum AMPLITUDE_DASHBOARDMENU_ENUM {
  ESTADISTICAS = 'ESTADISTICAS',
  ADMINISTRAR = 'ADMINISTRAR',
  PROYECTOS = 'PROYECTOS',
  BILLING = 'BILLING',
  PAYMENT_METHODS = 'PAYMENT_METHODS',
  SKILL_IQ = 'SKILL_IQ',
  CLASSROOM = 'CLASSROOM',
  CONFIGURACION = 'CONFIGURACION',
  AYUDA = 'AYUDA',
  FEEDBACK = 'FEEDBACK',
  GUIA_DEL_ADMINISTRADOR = 'GUIA_DEL_ADMINISTRADOR',
  STUDIO = 'STUDIO',
  SKILL_XP_EVOLUTION = 'SKILL_XP_EVOLUTION',
  TALENTO = 'TALENTO',
}
